import AbstractReportHeading from "./AbstractReportHeading";
import { formatDate } from "../../../utils/datetime";
import { VehicleType } from "../../vehicles/types";

const VehicleHeading = ({
	fileName,
	vehicle,
}: {
	fileName: string;
	vehicle: VehicleType;
}) => {
	const today = formatDate(new Date());
	return (
		<AbstractReportHeading
			fileName={fileName}
			leftTitle={vehicle.plate}
			rightTitle={vehicle.clientName}
			date={today}
			refValue={`#${vehicle.id}`}
			subject={vehicle.plate}
			extraRows={[
				{
					label: "Ref",
					value: `${vehicle.vinNumber} – ${vehicle.make} ${vehicle.model}`,
				},
			]}
		/>
	);
};

export default VehicleHeading;
